import { ManagementCompany } from "../../Interfaces"
import AddCompanyButton from "../../components/construction/AddCompanyButton"
import CwDataTable from "../../components/construction/CwDataTable"
import CwPageHeader from "../../components/construction/CwPageHeader"
import { t } from "../../i18n"
import { CircularProgress } from "@mui/material"

export default function CompaniesPageView({
  companies,
  isLoading,
  error,
  onAdd,
  onSelect,
}: {
  companies: ManagementCompany[]
  isLoading?: boolean
  error?: string | null
  onAdd: () => void
  onSelect: (company: ManagementCompany) => void
}) {
  return (
    <div className="w-full">
      <CwPageHeader
        title={t("companies.title")}
        subtitle={t("companies.subtitle")}
        action={<AddCompanyButton onClick={onAdd} />}
      />

      {isLoading ? (
        <div className="bg-white rounded-2xl shadow-lg h-48 flex items-center justify-center">
          <CircularProgress />
        </div>
      ) : error ? (
        <p className="bg-white rounded-2xl shadow-lg px-5 py-8 text-center text-red-600 font-source">
          {error}
        </p>
      ) : companies.length === 0 ? (
        <div className="bg-white rounded-2xl shadow-lg px-6 py-16 text-center font-source">
          <p className="text-gray-600 mb-4">{t("companies.empty")}</p>
          <AddCompanyButton onClick={onAdd} />
        </div>
      ) : (
        <CwDataTable
          columns={[
            { key: "name", label: t("companies.columnCompany") },
            {
              key: "code",
              label: t("companies.columnCode"),
              render: (row) => row.code || "",
            },
          ]}
          rows={companies}
          onRowClick={onSelect}
        />
      )}
    </div>
  )
}
